import { useSelector } from "react-redux";
import { outOfStockShortText } from "../store/orderingSlice";

export function InvalidSVG({ show = false }) {
  const out_of_stock_short_text = useSelector(outOfStockShortText);

  return show ? (
    <svg className="invalid-strike" role="img" aria-label={out_of_stock_short_text}>
      <line x1="100%" y1="100%" x2="0" y2="0"></line>
    </svg>
  ) : (
    <></>
  );
}
